export const mediaQueryResolutions = {
  desktopMinWidthResolution: '(min-width: 1024px)',
  desktopMinHeightResolution: '(min-height:890px)',
};
